import React from 'react';
import ReactDOM from 'react-dom/client';
import { scan } from 'react-scan';

import { CONFIG } from '@/config/config.ts';
import { initErrorMonitoring } from '@/monitoring/sentry.util.ts';
import { reloadAfterChunkLoadError } from '@/utils/appReload.util.ts';

import './i18n';
import './index.css';
import App from './App.tsx';

if ('scrollRestoration' in globalThis.history) {
  globalThis.history.scrollRestoration = 'manual';
}

if (globalThis.location.host === 'localhost:3000' && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      console.debug('Unregistering Service Worker');
      void registration.unregister();
    }
  });
}

globalThis.addEventListener('vite:preloadError', () => {
  reloadAfterChunkLoadError();
});

initErrorMonitoring();

scan({
  enabled: CONFIG.PERFORMANCE_SCAN === 'true',
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
